import { AVAILABILITY_OPTIONS, SORTING_DIRECTION } from 'src/constants/main';
import { ILangTextValidation, TBooleanInNumber, TTranslate } from 'src/types/main';

export interface IExclusion {
  id: number;
  external_id?: string | number;
  name: TTranslate;
  status: TBooleanInNumber;
  is_delete: TBooleanInNumber;
  is_draft?: boolean;
}

export interface IExclusionsFilters {
  search: string;
  availability: AVAILABILITY_OPTIONS | undefined;
  sort_field: EXCLUSIONS_COLUMN_NAME;
  sort_dir: SORTING_DIRECTION;
}

export enum EXCLUSIONS_COLUMN_NAME {
  NAME = 'name',
}

export interface IExclusionValidation {
  valid: boolean;
  name: ILangTextValidation;
}
